/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FoodWareDishIcon20Light = forwardRef('FoodWareDishIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10 5.915a1.5 1.5 0 1 0-1 0v1.102a7.562 7.562 0 0 0-4.803 2.18A7.568 7.568 0 0 0 2 14.5a.5.5 0 0 0 1 0c0-1.707.697-3.389 1.904-4.596A6.559 6.559 0 0 1 9.5 8c1.707 0 3.389.697 4.596 1.904A6.559 6.559 0 0 1 16 14.5a.5.5 0 0 0 1 0c0-1.97-.804-3.91-2.197-5.303A7.562 7.562 0 0 0 10 7.017V5.915Z" }),
        React.createElement("path", { d: "M.5 16a.5.5 0 0 0 0 1h18a.5.5 0 0 0 0-1H.5Z" })));
});
